<template>
<nav class="custom-nav">
        <Dropdown title="ΔΙΑΜΟΝΗ" titlen="ACCOMMODATION" :items="services" :itemsen="servicesen"/>
</nav>
</template>

<script>
import Dropdown from './Dropdown'

export default{
    name: 'white-navbar',
    components: {
        Dropdown
    },
     data () {
        return{
            services: [
                {
                    title: 'Δίκλινο Δωμάτιο',
                    link: '/diklino-domatio/'
                },
                {
                    title: 'Τρίκλινο Δωμάτιο',
                    link: '/triklino-domatio/'
                },
                {
                    title: 'Δίκλινο Δωμάτιο',
                    link: '/diklino/'
                },
            ],
            servicesen: [
                {
                    title: 'Double Room',
                    link: '/diklino-domatio/?lang=en'
                },
                {
                    title: 'Triple Room',
                    link: '/triklino-domatio/?lang=en'
                },
                {
                    title: 'Double Room',
                    link: '/diklino//?lang=en'
                },
            ],
           
        }
    }

}
</script>
<style >
 nav{
        display: flex;
        align-items: center;
    }
.sidebar-drop{
    position: absolute !important;
    left: 0px;
}
    nav .menu-item{
        color:#fff;
        position: relative;
        text-align:center;
        border-bottom: 3px solid transparent;
        display: flex;
        transition: 0.4s;
    }

    nav .menu-item a{
        color:inherit;
        text-decoration:none;
    }
</style>